import { AnimatePresence } from 'framer-motion';
import { useEffect, useState } from 'react';

import PaymentRateExpired from '../PaymentRateExpired/PaymentRateExpired';
import PaymentWaiting from '../PaymentWaiting/PaymentWaiting';

import { PageFields_PaymentExpiredPage_Fragment as PaymentExpiredPageFields } from '../../graphql/generated';
import { scrollToTop } from '../../utils';
import { usePhoneMockupLayoutContext } from '@frontend/ui-library';

enum Screen {
  EXPIRED,
  PAYMENT_WAITING,
}

interface PaymentRateExpiredFlowProps {
  data: PaymentExpiredPageFields['pageData'];
}

export default function PaymentRateExpiredFlow({
  data,
}: PaymentRateExpiredFlowProps): JSX.Element {
  const [screen, setScreen] = useState<Screen>(Screen.EXPIRED);
  const { animationDirection, setAnimationDirection } =
    usePhoneMockupLayoutContext();

  const { paymentExpiredConfirmedTransactions: transactions } = data;

  useEffect(() => {
    if (transactions) {
      setScreen(Screen.EXPIRED);
    }
  }, [transactions]);

  const handleWaitingScreenGoBack = () => {
    setScreen(Screen.EXPIRED);
    setAnimationDirection('backwards');
  };

  const handleMadePaymentClick = () => {
    setScreen(Screen.PAYMENT_WAITING);
    setAnimationDirection('forwards');
  };

  return (
    <AnimatePresence
      custom={animationDirection}
      mode="wait"
      onExitComplete={scrollToTop}
    >
      {screen === Screen.PAYMENT_WAITING ? (
        <PaymentWaiting
          billType={data.billType || ''}
          merchantName={data.merchantName || ''}
          key={Screen.PAYMENT_WAITING}
          billExpiresAt={data.paymentExpiredExpiresAt || undefined}
          onGoBack={handleWaitingScreenGoBack}
        />
      ) : (
        <PaymentRateExpired
          key={Screen.EXPIRED}
          data={data}
          onMadePaymentClick={handleMadePaymentClick}
        />
      )}
    </AnimatePresence>
  );
}
